import { PerfilDeOrganizacao } from "@/types/gerais"

interface UsarClarity {
  enviarPerfilOrganizacaoAoClarity: (perfilOrganizacional: PerfilDeOrganizacao) => void
  habilitarClarityComConsentimento: () => void
}

export function usarClarity(): UsarClarity {
  const possuiInstanciaValida = (): boolean => {
    let existeInstanciaValida = true
    if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, 'clarity')) {
      existeInstanciaValida = false
    }

    return existeInstanciaValida
  }

  const enviarPerfilOrganizacaoAoClarity = (perfilOrganizacional: PerfilDeOrganizacao): void => {
    if (!possuiInstanciaValida()) {
      return
    }
    window['clarity']('set', 'perfilOrganizacional', perfilOrganizacional)
  }

  const habilitarClarityComConsentimento = (): void => {
    if (!possuiInstanciaValida()) {
      return
    }
    window['clarity']('consent')
  }

  return {
    enviarPerfilOrganizacaoAoClarity,
    habilitarClarityComConsentimento
  }
}
